var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 109,
    viewBox: "0 0 191 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 69C144.856 70.8089 118.77 77.288 135.58 88.7333C152.39 100.179 128.198 105.013 114 106",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8333 88.5C80.3635 88.875 78.082 93.0312 77.5 95.0625L88.5 98.5L84.8333 88.5Z",
    fill: "#BAC3D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50003 34L3.50003 27.5C3.10003 13.1 17 7.16667 24 6L31.5 15.5C20.3 16.7 12.3334 28 9.50003 34Z",
    fill: "#BAC3D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6L77.5 65L88.5 99",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6C16.5 6 4.2 11.3 3 26.5",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 27L56 88.5L88.5 99",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 88.5C57.8333 82.3333 63.7 70.2 76.5 67",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.568 52.4852C162.686 48.2385 147 33.7117 147 22.3756C147 8.95024 155.8 0 169 0C182.2 0 191 11.1878 191 22.3756C191 31.8679 175.163 47.8035 170.363 52.4153C169.58 53.1676 168.386 53.1972 167.568 52.4852ZM176.333 19.3922C176.333 23.5114 173.05 26.8507 169 26.8507C164.95 26.8507 161.667 23.5114 161.667 19.3922C161.667 15.273 164.95 11.9337 169 11.9337C173.05 11.9337 176.333 15.273 176.333 19.3922Z",
    fill: "#BAC3D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcAddress);
export default __webpack_public_path__ + "static/media/oc-address.016f5e022ef001fd458ece242792bc96.svg";
export { ForwardRef as ReactComponent };